import { Workflow } from 'lucide-react';

import { cn } from '@/lib/utils';

import { type WorkflowCommandOption } from './helpers/workflow-slash';
interface WorkflowSlashMenuProps {
  options: WorkflowCommandOption[];
  activeIndex: number;
  isLoading: boolean;
  onHover: (index: number) => void;
  onSelect: (option: WorkflowCommandOption) => void;
}

export function WorkflowSlashMenu({
  options,
  activeIndex,
  isLoading,
  onHover,
  onSelect,
}: WorkflowSlashMenuProps) {
  return (
    <div className='absolute bottom-full left-0 right-0 z-20 mb-2 overflow-hidden rounded-xl border border-border bg-popover shadow-lg'>
      <p className='border-b border-border/60 px-3 py-1.5 text-[11px] font-medium uppercase tracking-wide text-muted-foreground'>
        Run a workflow
      </p>
      <div className='max-h-64 overflow-y-auto p-1'>
        {isLoading && options.length === 0 && (
          <p className='px-2 py-2 text-sm text-muted-foreground'>
            Loading workflows...
          </p>
        )}
        {!isLoading && options.length === 0 && (
          <p className='px-2 py-2 text-sm text-muted-foreground'>
            No matching workflows.
          </p>
        )}
        {options.map((option, index) => (
          <button
            key={option.workflowId}
            type='button'
            className={cn(
              'flex w-full items-start gap-2 rounded-lg px-2 py-1.5 text-left',
              index === activeIndex && 'bg-accent',
            )}
            onMouseEnter={() => onHover(index)}
            onMouseDown={(e) => {
              e.preventDefault();
              onSelect(option);
            }}
          >
            <Workflow className='mt-0.5 size-4 shrink-0 text-primary' />
            <span className='min-w-0 flex-1'>
              <span className='block truncate text-sm font-medium'>
                {option.name}
              </span>
              {option.description && (
                <span className='block truncate text-xs text-muted-foreground'>
                  {option.description}
                </span>
              )}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
